module.exports = __webpack_public_path__ + "static/logo-tau-ai-te-ira-7068eed8182a2a2772a0e44e4f91b6d1.png";